import React, { useEffect, useState } from "react";

import "./tentangkami.css";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

import AOS from "aos";

export default function TentangKami() {
  const [isActive, setIsActive] = useState("tentangkami");

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  return (
    <>
      <Navbar isActive={isActive} />
      <div className="mainContentTentangKami pt-5 backgroundColorTentagKami py-3">
        <div className="container rounded-4 " data-aos="zoom-in">
          <h1 className="text-center pt-5 pb-3 text-danger fw-bold">
            Tentang Kami
          </h1>
          <div className="d-lg-flex m-4">
            <div className="text-center">
              <img
                src={require("../../assets/laptop.jpg")}
                alt="CONTENT TWO"
                className="shadow-lg rounded"
                width={"60%"}
              />
            </div>
            <div className="listTentangKamiSatu fs-5">
              <ul>
                <li>
                  <h5 className="fw-bold">Tahun 2018</h5>
                  <p>
                    Mengawali bisnis di bidang Event Solution, yang telah
                    mendapatkan kepercayaan dari berbagai pihak baik instansi
                    pemerintah maupun swasta.
                  </p>
                </li>
                <li>
                  <h5 className="fw-bold">Tahun 2019</h5>
                  <p>
                    Kami melakukan diversifikasi usaha dengan membuka unit
                    bisnis baru yaitu Outsourcing Agency yang menyediakan tenaga
                    kerja professional.
                  </p>
                  <p>
                    Kami juga membuat sebuah Aplikasi Phoenix yang sangat
                    dibutuhkan oleh para principal, distributor dan perusahaan
                    manufaktur untuk keperluan Human Resources Management dalam
                    memonitor pergerakan barang (inventory) penjualan, memantau
                    aktifitas pekerja, dan pasar serta dapat memberikan
                    laporan-laporan secara realtime.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div className="listTentangKamiDua fs-5">
            <ul>
              <li>
                <h5 className="fw-bold">Tahun 2020</h5>
                <p>
                  Kami kembali mengembangkan usaha di bidang Online & Offline
                  Distribution. Untuk membantu produk Anda terdistribusi dengan
                  baik dan kami pastikan produk unggulan Anda hadir di seluruh
                  jaringan pemasaran sesuai dengan rencana bisnis Anda.
                </p>
              </li>
              <li>
                <h5 className="fw-bold">Tahun 2022</h5>
                <p>
                  Kami merilis produk aplikasi berbasis web (NusaCRM) yang dapat
                  memudahkan pelaku bisnis melakukan Whatsapp blasting dan
                  berkomunikasi dengan customer. Aplikasi NusaCRM memiliki
                  berbagai fitur unggulan seperti chatbot, automation dan live
                  chat.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
